export const r2Domain = (() => {
  if (location.hostname === 'ipaperclip.cfm.moe') return 'ipaperclip-r2.cfm.moe'
  else return 'r2.ipaperclip.icu'
})()
